// Auto-generated routes for throwaway UI mockups.
//
// Drop a `{Feature}MockupV{N}.vue` file under `src/views/Mockups/{Feature}/`
// and it is exposed automatically at `/mockups/{feature}/v{N}` — you never edit
// this file or routes.js by hand. `{feature}` is the folder name kebab-cased.
//
// See `.claude/skills/mockup/SKILL.md` for the full convention.

import { userType } from "@utils/constants/userRoles";

const modules = import.meta.glob("./*/*MockupV*.vue");

// Mockups are internal tooling. Gate every route to Episto staff so a client
// never lands on one (logged-out -> Login, client -> Forbidden), even though
// there's no real path for them to reach it.
const MOCKUP_META = {
  layout: "blank",
  requiresAuth: true,
  userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
};

// CreditMonitoring -> credit-monitoring, AIInsights -> ai-insights
function toKebab(name) {
  return name
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
    .toLowerCase();
}

// Parsed list of every mockup found on disk — also consumed by MockupsIndex.vue.
export const mockups = Object.entries(modules)
  .map(([path, loader]) => {
    // path example: ./CreditMonitoring/CreditMonitoringMockupV2.vue
    const match = path.match(/^\.\/([^/]+)\/[^/]+MockupV(\d+)\.vue$/);
    if (!match) return null;
    const [, folder, versionNumber] = match;
    const feature = toKebab(folder);
    return {
      folder,
      feature,
      version: `v${versionNumber}`,
      versionNumber: Number(versionNumber),
      path: `/mockups/${feature}/v${versionNumber}`,
      loader,
    };
  })
  .filter(Boolean)
  .sort((a, b) => a.folder.localeCompare(b.folder) || a.versionNumber - b.versionNumber);

const mockupRoutes = mockups.map(({ folder, version, path, loader }) => ({
  name: `Mockup-${folder}-${version}`,
  path,
  component: loader,
  meta: { title: `Mockup · ${folder} ${version}`, ...MOCKUP_META },
}));

export default [
  {
    name: "MockupsIndex",
    path: "/mockups",
    component: () => import("./MockupsIndex.vue"),
    meta: { title: "Mockups", ...MOCKUP_META },
  },
  ...mockupRoutes,
];
